import './Guidelines.scss';
import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";

// Keep in step with GUIDELINES_VERSION in backend settings: bumping the backend
// version asks every author to agree again at their next publish, so the date
// shown here should be the date of that change.
export const GUIDELINES_UPDATED = '١٦ أكتوبر ٢٠٢٦';
export const CONTACT_EMAIL = 'contact@rawiyaih.com';

const FORBIDDEN = [
    {
        title: 'المحتوى الجنسي الصريح',
        text: 'المشاهد الجنسية الصريحة أو الإباحية بأي شكل. وأي محتوى جنسي يتعلق بالقاصرين يُحذف فورًا ويُبلَّغ عنه إلى الجهات المختصة.',
    },
    {
        title: 'الإساءة إلى الأديان والمقدسات',
        text: 'الإساءة إلى الذات الإلهية أو الأنبياء أو الكتب السماوية أو الرموز الدينية، أو ازدراء الأديان والمذاهب، أو التحريض على الكراهية الدينية أو الطائفية.',
    },
    {
        title: 'خطاب الكراهية والتمييز',
        text: 'التحقير أو التحريض ضد أشخاص أو جماعات على أساس الدين أو المذهب أو العرق أو الجنسية أو القبيلة أو اللون أو الجنس أو الإعاقة.',
    },
    {
        title: 'العنف والإرهاب',
        text: 'التحريض على العنف أو الإرهاب أو تمجيده، أو الترويج لجماعات أو تنظيمات متطرفة أو لأفكارها.',
    },
    {
        title: 'الإخلال بالأمن والنظام العام',
        text: 'ما يمس أمن الدولة أو النظام العام أو الآداب العامة، أو ما يخالف الأنظمة المعمول بها في المملكة العربية السعودية أو في بلد الكاتب.',
    },
    {
        title: 'التشهير والخصوصية',
        text: 'التشهير بالأشخاص أو الجهات، أو نشر معلومات شخصية عن الآخرين دون إذنهم، أو انتحال شخصية شخص آخر.',
    },
    {
        title: 'إيذاء النفس',
        text: 'الترويج للانتحار أو إيذاء النفس أو اضطرابات الأكل، أو تقديم تعليمات أو تشجيع عليها.',
    },
    {
        title: 'الأنشطة غير القانونية',
        text: 'الترويج للمخدرات أو السلاح أو الاحتيال أو القرصنة أو أي نشاط غير قانوني، أو تقديم تعليمات لتنفيذه.',
    },
    {
        title: 'انتهاك حقوق الملكية',
        text: 'نشر أعمال الآخرين أو أجزاء منها دون إذن صاحبها، أو نسب عمل إلى غير كاتبه. انشر ما كتبته أنت فقط.',
    },
    {
        title: 'الرسائل المزعجة والروابط الضارة',
        text: 'المحتوى الدعائي المتكرر، والروابط الخبيثة أو المضللة، والحسابات المنشأة لهذا الغرض.',
    },
];

export default function Guidelines() {
    const { hash } = useLocation();

    // BrowserRouter doesn't scroll to #anchors on its own.
    useEffect(() => {
        if (!hash) { window.scrollTo(0, 0); return; }
        document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, [hash]);

    return (
        <>
        <Navbar />
        <main className='gl-page'>
            <div className='gl-container'>
                <header className='gl-header'>
                    <h1>إرشادات النشر</h1>
                    <p>
                        ما يُسمح بنشره على راوية وما لا يُسمح به. بنشر أي عمل على المنصة فأنت توافق على هذه
                        الإرشادات وتتحمل المسؤولية الكاملة عمّا تنشره.
                    </p>
                </header>

                <nav className='gl-toc' aria-label='أقسام الصفحة'>
                    <a href='#forbidden'>ما لا يُسمح بنشره</a>
                    <a href='#sensitive'>المحتوى الحساس</a>
                    <a href='#rights'>حقوق الملكية</a>
                    <a href='#reports'>التبليغ والإزالة</a>
                    <a href='#disclaimer'>إخلاء المسؤولية</a>
                </nav>

                <section className='gl-section' id='forbidden'>
                    <h2>ما لا يُسمح بنشره</h2>
                    <p className='gl-lead'>يُحذف أي عمل يحتوي على ما يلي، وقد يؤدي تكرار المخالفة إلى إيقاف الحساب:</p>
                    <ol className='gl-rules'>
                        {FORBIDDEN.map(r => (
                            <li key={r.title}>
                                <strong>{r.title}</strong>
                                <span>{r.text}</span>
                            </li>
                        ))}
                    </ol>
                </section>

                <section className='gl-section' id='sensitive'>
                    <h2>المحتوى الحساس</h2>
                    <p>
                        الأدب يتناول أحيانًا موضوعات ثقيلة: العنف، والحرب، والفقد، والمرض، والجريمة. هذا مقبول في سياق
                        العمل الأدبي ما لم يكن غرضه التمجيد أو التحريض أو الوصف الصريح لذاته. إذا كان عملك يحتوي على
                        مشاهد قد تزعج بعض القرّاء، فمن اللائق التنبيه إلى ذلك في نبذة الكتاب.
                    </p>
                </section>

                <section className='gl-section' id='rights'>
                    <h2>حقوق الملكية</h2>
                    <p>
                        تبقى الحقوق الكاملة لعملك لك. بنشره على راوية تمنح المنصة إذنًا بعرضه للقرّاء هنا فقط، ويمكنك
                        إلغاء نشره في أي وقت. وتؤكد بالنشر أنك كاتب العمل أو أن لديك إذنًا صريحًا من صاحبه، وأن العمل لا
                        ينتهك حقوق أي طرف آخر.
                    </p>
                </section>

                <section className='gl-section' id='reports'>
                    <h2>التبليغ والإزالة</h2>
                    <p>
                        لا تراجع راوية الأعمال قبل نشرها. إذا وجدت عملًا يخالف هذه الإرشادات فراسلنا على{' '}
                        <a href={`mailto:${CONTACT_EMAIL}`} dir='ltr'>{CONTACT_EMAIL}</a> مع رابط العمل وسبب البلاغ.
                        نراجع البلاغات ونزيل المحتوى المخالف ونوقف الحسابات المخالفة عند اللزوم، وقد نبلّغ الجهات
                        المختصة إذا اقتضى الأمر ذلك.
                    </p>
                </section>

                <section className='gl-section gl-disclaimer' id='disclaimer'>
                    <h2>إخلاء المسؤولية</h2>
                    <ul>
                        <li>
                            راوية منصة تقنية تتيح للكتّاب نشر أعمالهم، ولا تؤلّف المحتوى المنشور عليها ولا تتبنّاه. الآراء
                            والأفكار والمواقف الواردة في أي عمل تعبّر عن كاتبه وحده، ولا تعبّر عن رأي راوية أو القائمين
                            عليها.
                        </li>
                        <li>
                            يتحمّل كاتب العمل وحده المسؤولية القانونية والأدبية الكاملة عن كل ما ينشره، بما في ذلك
                            مطابقته للأنظمة المعمول بها وحقوق الآخرين. وبموافقتك على هذه الإرشادات تقرّ بذلك، وتُعفي
                            راوية والقائمين عليها من أي مطالبة أو مسؤولية تنشأ عن محتواك.
                        </li>
                        <li>
                            لا تراجع راوية الأعمال قبل نشرها ولا تضمن دقتها أو صحتها أو ملاءمتها لكل القرّاء. يقرأ
                            القارئ على مسؤوليته الخاصة.
                        </li>
                        <li>
                            تحتفظ راوية بحقها في حذف أي محتوى أو إيقاف أي حساب يخالف هذه الإرشادات دون إشعار مسبق،
                            وفي تعديل هذه الإرشادات في أي وقت؛ وعند تعديلها جوهريًا يُطلب من الكتّاب الموافقة عليها مجددًا
                            عند النشر التالي.
                        </li>
                    </ul>
                </section>

                <footer className='gl-footer'>
                    <span>آخر تحديث: {GUIDELINES_UPDATED}</span>
                    <Link to='/library'>العودة إلى المكتبة</Link>
                </footer>
            </div>
        </main>
        <Footer />
        </>
    );
}
